module.exports = __webpack_public_path__ + "img/NO.d96fb3ec.svg";